import { useState, useEffect } from 'react';
import { getAllNftsFromAlchemy } from '../providers/AlchemyProvider';
import { AssetModel } from '../models';
import { NOT_A_REAL_ID, BASEJUMP_BI_CONTRACT_ADDRESS } from '../constants';
import { Network } from 'alchemy-sdk';
import {
  getEquipmentItems,
} from '../providers/BasejumpApiProvider';

const IS_PRODUCTION = (process.env.REACT_APP_IS_PRODUCTION || 'false').toLowerCase() === 'true'

const MOCK_ASSETS = [
  {
    id: 999,
    type: 'object',
    subtype: 'drone_mutatio',
    name: 'Mutatio test',
    glb: 'https://arweave.net/lTP0cpqw0cSxOxoDqJtRgLpqxszOjjC7a5YpLtr9Rx0',
    image: 'https://arweave.net/uNqH0vh7jbI_vFs2RNnzDlY_8zaZNqUbQa7uvnuo9Xs',
    description: 'Mutatio test'
  },
  {
    id: 1,
    type: 'object',
    subtype: 'drone_dance',
    name: 'BoomBoxDrone #1',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/3DBassBoomboxDrone/Item_Drone_3DBass_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/3DBassBoomboxDrone/BoomboxDrone3DBassBlack.png',
    description: '3DBass Boom Box Drone'
  },
  {
    id: 11,
    type: 'object',
    subtype: 'drone_dance',
    name: 'BoomBoxDrone #2',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/3DBassBoomboxDrone/Item_Drone_3DBass_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/3DBassBoomboxDrone/BoomboxDroneOGBlackpink.png',
    description: '3DBass Boom Box Drone'
  },
  {
    id: 111,
    type: 'object',
    subtype: 'drone_dance',
    name: 'BoomBoxDrone #3',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/3DBassBoomboxDrone/Item_Drone_3DBass_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/3DBassBoomboxDrone/BoomboxDroneBonesUpGold.png',
    description: '3DBass Boom Box Drone'
  },
  {
    id: 1111,
    type: 'object',
    subtype: 'drone_dance',
    name: 'BoomBoxDrone #4',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/3DBassBoomboxDrone/Item_Drone_3DBass_Superrare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/3DBassBoomboxDrone/BoomboxDroneDazzleCamo.png',
    description: '3DBass Boom Box Drone'
  },
  {
    id: 11111,
    type: 'object',
    subtype: 'drone_dance',
    name: 'BoomBoxDrone #5',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/3DBassBoomboxDrone/Item_Drone_3DBass_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/3DBassBoomboxDrone/BoomboxDroneOGPink.png',
    description: '3DBass Boom Box Drone'
  },
  {
    id: 2,
    type: 'weapon',
    subtype: 'light',
    name: '4BarreledNailgun #1',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/4BarreledNailgun/Item_Weapon_Gun_4BarreledNailgun_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/4BarreledNailgun/4BarrellNailgunOGPinkEdition.png',
    animationType: 'aim_1h',
    description: '4 Barreled Nailgun'
  },
  {
    id: 22,
    type: 'weapon',
    subtype: 'light',
    name: '4BarreledNailgun #2',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/4BarreledNailgun/Item_Weapon_Gun_4BarreledNailgun_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/4BarreledNailgun/4BarrellNailgunProtaStealthEdition.png',
    animationType: 'aim_1h',
    description: '4 Barreled Nailgun'
  },
  {
    id: 222,
    type: 'weapon',
    subtype: 'light',
    name: '4BarreledNailgun #3',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/4BarreledNailgun/Item_Weapon_Gun_4BarreledNailgun_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/4BarreledNailgun/4BarrelNailgunBonesUpEdition.png',
    animationType: 'aim_1h',
    description: '4 Barreled Nailgun'
  },
  {
    id: 2222,
    type: 'weapon',
    subtype: 'light',
    name: '4BarreledNailgun #4',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/4BarreledNailgun/Item_Weapon_Gun_4BarreledNailgun_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/4BarreledNailgun/4BarrelNailgunInvisibleHandEdition.png',
    animationType: 'aim_1h',
    description: '4 Barreled Nailgun'
  },
  {
    id: 22222,
    type: 'weapon',
    subtype: 'light',
    name: '4BarreledNailgun #5',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/4BarreledNailgun/Item_Weapon_Gun_4BarreledNailgun_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/4BarreledNailgun/4BarrelNailgunOGOrangeEdition.png',
    animationType: 'aim_1h',
    description: '4 Barreled Nailgun'
  },
  {
    id: 3,
    type: 'weapon',
    subtype: 'light',
    name: 'ADSHeatBluster #1',
    animationType: 'aim_1h',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ADSHeatBlaster/Item_Weapon_Sub_ADSHeatBlaster_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ADSHeatBlaster/ProtaSilverADSHeatBlaster.png',
    description: 'ADS Heat Blaster'
  },
  {
    id: 33,
    type: 'weapon',
    subtype: 'light',
    name: 'ADSHeatBluster #2',
    animationType: 'aim_1h',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ADSHeatBlaster/Item_Weapon_Sub_ADSHeatBlaster_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ADSHeatBlaster/SunKidsADSHeatBlaster.png',
    description: 'ADS Heat Blaster'
  },
  {
    id: 333,
    type: 'weapon',
    subtype: 'light',
    name: 'ADSHeatBluster #3',
    animationType: 'aim_1h',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ADSHeatBlaster/Item_Weapon_Sub_ADSHeatBlaster_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ADSHeatBlaster/ProtaGoldADSHeatBlaster.png',
    description: 'ADS Heat Blaster'
  },
  {
    id: 3333,
    type: 'weapon',
    subtype: 'light',
    name: 'ADSHeatBluster #4',
    animationType: 'aim_1h',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ADSHeatBlaster/Item_Weapon_Sub_ADSHeatBlaster_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ADSHeatBlaster/HackedADSHeatBlaster.png',
    description: 'ADS Heat Blaster'
  },
  {
    id: 33333,
    type: 'weapon',
    subtype: 'light',
    name: 'ADSHeatBluster #5',
    animationType: 'aim_1h',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ADSHeatBlaster/Item_Weapon_Sub_ADSHeatBlaster_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ADSHeatBlaster/ProtaAnodizedADSHeatBlaster.png',
    description: 'ADS Heat Blaster'
  },
  {
    id: 4,
    type: 'object', //'armor'
    subtype: 'shield',
    name: 'ArmorShield3DBass #1',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ArmourShield3DBass/Item_Armour_Shield_3DBass_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ArmourShield3DBass/3DBassShieldOGAnodized.png',
    description: 'Armour Shield 3DBass'
  },
  {
    id: 44,
    type: 'object', //'armor'
    subtype: 'shield',
    name: 'ArmorShield3DBass #2',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ArmourShield3DBass/Item_Armour_Shield_3DBass_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ArmourShield3DBass/3DBassShieldStealthBlack.png',
    description: 'Armour Shield 3DBass'
  },
  {
    id: 444,
    type: 'object', //'armor'
    subtype: 'shield',
    name: 'ArmorShield3DBass #3',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ArmourShield3DBass/Item_Armour_Shield_3DBass_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ArmourShield3DBass/3DBassShieldFantaziaCamo.png',
    description: 'Armour Shield 3DBass'
  },
  {
    id: 4444,
    type: 'object', //'armor'
    subtype: 'shield',
    name: 'ArmorShield3DBass #4',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ArmourShield3DBass/Item_Armour_Shield_3DBass_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ArmourShield3DBass/3DBassShieldOGPink.png',
    description: 'Armour Shield 3DBass'
  },
  {
    id: 44444,
    type: 'object', //'armor'
    subtype: 'shield',
    name: 'ArmorShield3DBass #5',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/ArmourShield3DBass/Item_Armour_Shield_3DBass_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/ArmourShield3DBass/3DBassShieldDazzleCamo.png',
    description: 'Armour Shield 3DBass'
  },
  {
    id: 5,
    type: 'armor',
    name: 'BlackDetagHoodie #1',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/item_device_blackdetagpixelator_art_Common.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/Henchie/Henchie_item_device_blackdetagpixelator_art_Common.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BlackDetagHoody/DetagHoodyBlack.png',
    description: 'Black Detag Hoodie'
  },
  {
    id: 55,
    type: 'armor',
    name: 'BlackDetagHoodie #2',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/item_device_blackdetagpixelator_art_Legendary.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/Henchie/Henchie_item_device_blackdetagpixelator_art_Legendary.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BlackDetagHoody/DetagHoodyBonesUp.png',
    description: 'Black Detag Hoodie'
  },
  {
    id: 555,
    type: 'armor',
    name: 'BlackDetagHoodie #3',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/item_device_blackdetagpixelator_art_Rare.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/Henchie/Henchie_item_device_blackdetagpixelator_art_Rare.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BlackDetagHoody/DetagHoodyBayBlue.png',
    description: 'Black Detag Hoodie'
  },
  {
    id: 5555,
    type: 'armor',
    name: 'BlackDetagHoodie #4',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/item_device_blackdetagpixelator_art_SuperRare.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/Henchie/Henchie_item_device_blackdetagpixelator_art_SuperRare.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BlackDetagHoody/DetagHoodyInvisibleHand.png',
    description: 'Black Detag Hoodie'
  },
  {
    id: 55555,
    type: 'armor',
    name: 'BlackDetagHoodie #5',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/item_device_blackdetagpixelator_art_Uncommon.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BlackDetagHoody/Henchie/Henchie_item_device_blackdetagpixelator_art_Uncommon.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BlackDetagHoody/DetagHoodyOGPink.png',
    description: 'Black Detag Hoodie'
  },
  {
    id: 6,
    type: 'armor',
    name: 'BonesuitLegs #1',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BonesuitLegs/item_armour_legs_bonesuit_Common.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BonesuitLegs/BonesuitLegsOGPink.png',
    description: 'Bonesuit Legs'
  },
  {
    id: 66,
    type: 'armor',
    name: 'BonesuitLegs #2',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BonesuitLegs/item_armour_legs_bonesuit_Legendary.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BonesuitLegs/BonesuitLegsProtaStealth.png',
    description: 'Bonesuit Legs'
  },
  {
    id: 666,
    type: 'armor',
    name: 'BonesuitLegs #3',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BonesuitLegs/item_armour_legs_bonesuit_Rare.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BonesuitLegs/BonesuitLegsBonesUp.png',
    description: 'Bonesuit Legs'
  },
  {
    id: 6666,
    type: 'armor',
    name: 'BonesuitLegs #4',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BonesuitLegs/item_armour_legs_bonesuit_SuperRare.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BonesuitLegs/BonesuitLegsInvisibleHandRemix.png',
    description: 'Bonesuit Legs'
  },
  {
    id: 66666,
    type: 'armor',
    name: 'BonesuitLegs #5',
    glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/BonesuitLegs/item_armour_legs_bonesuit_Uncommon.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/BonesuitLegs/BonesuitLegsOGOrange.png',
    description: 'Bonesuit Legs'
  },
  {
    id: 7,
    type: 'object',
    subtype: 'equip',
    name: 'Burger #1',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/Burger/Item_Edible_Food_Burger_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/Burger/BubbleKitchenBurger.png',
    description: 'Burger',
  },
  {
    id: 77,
    type: 'object',
    subtype: 'equip',
    name: 'Burger #2',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/Burger/Item_Edible_Food_Burger_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/Burger/DrDinushaSpecial.png',
    description: 'Burger',
  },
  {
    id: 777,
    type: 'object',
    subtype: 'equip',
    name: 'Burger #3',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/Burger/Item_Edible_Food_Burger_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/Burger/BigChungusBurger.png',
    description: 'Burger',
  },
  {
    id: 7777,
    type: 'object',
    subtype: 'equip',
    name: 'Burger #4',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/Burger/Item_Edible_Food_Burger_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/Burger/SolarpunkVeggieBurger.png',
    description: 'Burger',
  },
  {
    id: 77777,
    type: 'object',
    subtype: 'equip',
    name: 'Burger #5',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/Burger/Item_Edible_Food_Burger_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/Burger/BubbleKitchenCheeseburger.png',
    description: 'Burger',
  },
  {
    id: 8,
    type: 'weapon',
    name: 'DoubleBarrellSniper #1',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistolSniper/Item_Weapon_Gun_EMPPistolSniper_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistolSniper/DoubleBarrel7ScopeSniperOGPinkEdition.png',
    description: 'Double Barrel Seven Scoped Sniper'
  },
  {
    id: 88,
    type: 'weapon',
    name: 'DoubleBarrellSniper #2',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistolSniper/Item_Weapon_Gun_EMPPistolSniper_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistolSniper/DoubleBarrel7ScopeSniperProtaStealthEdition.png',
    description: 'Double Barrel Seven Scoped Sniper'
  },
  {
    id: 888,
    type: 'weapon',
    name: 'DoubleBarrellSniper #3',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistolSniper/Item_Weapon_Gun_EMPPistolSniper_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistolSniper/DoubleBarrel7ScopeSniperBonesUpEdition.png',
    description: 'Double Barrel Seven Scoped Sniper'
  },
  {
    id: 8888,
    type: 'weapon',
    name: 'DoubleBarrellSniper #4',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistolSniper/Item_Weapon_Gun_EMPPistolSniper_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistolSniper/DoubleBarrel7ScopeSniperInvisibleHandEdition.png',
    description: 'Double Barrel Seven Scoped Sniper'
  },
  {
    id: 88888,
    type: 'weapon',
    name: 'DoubleBarrellSniper #5',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistolSniper/Item_Weapon_Gun_EMPPistolSniper_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistolSniper/DoubleBarrel7ScopeSniperOGOrangeEdition.png',
    description: 'Double Barrel Seven Scoped Sniper'
  },
  {
    id: 9,
    type: 'object',
    subtype: 'equip',
    name: 'DroneBlockerPistol #1',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/DroneBlockerPistol/Item_Weapon_DroneBlocker_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/DroneBlockerPistol/DroneBlockerSilver.png',
    description: 'Drone Blocker (Pistol)',
  },
  {
    id: 99,
    type: 'object',
    subtype: 'equip',
    name: 'DroneBlockerPistol #2',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/DroneBlockerPistol/Item_Weapon_DroneBlocker_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/DroneBlockerPistol/DroneBlockerStealth.png',
    description: 'Drone Blocker (Pistol)',
  },
  {
    id: 999,
    type: 'object',
    subtype: 'equip',
    name: 'DroneBlockerPistol #3',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/DroneBlockerPistol/Item_Weapon_DroneBlocker_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/DroneBlockerPistol/DroneBlockerInvisibleHandSpecial.png',
    description: 'Drone Blocker (Pistol)',
  },
  {
    id: 9999,
    type: 'object',
    subtype: 'equip',
    name: 'DroneBlockerPistol #4',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/DroneBlockerPistol/Item_Weapon_DroneBlocker_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/DroneBlockerPistol/DroneBlockerDazzleCamo.png',
    description: 'Drone Blocker (Pistol)',
  },
  {
    id: 99999,
    type: 'object',
    subtype: 'equip',
    name: 'DroneBlockerPistol #5',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/DroneBlockerPistol/Item_Weapon_DroneBlocker_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/DroneBlockerPistol/DroneBlockerOGPink.png',
    description: 'Drone Blocker (Pistol)',
  },
  {
    id: 10,
    type: 'weapon',
    name: 'EMPPistol #1',
    subtype: 'light',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistol/Item_Weapon_Gun_EMPPistol_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistol/EMPPistolOGGoldEdition.png',
    animationType: 'aim_1h',
    description: 'EMP Pistol'
  },
  {
    id: 1010,
    type: 'weapon',
    name: 'EMPPistol #2',
    subtype: 'light',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistol/Item_Weapon_Gun_EMPPistol_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistol/EMPPistolOGDazzleCamoEdition.png',
    animationType: 'aim_1h',
    description: 'EMP Pistol'
  },
  {
    id: 101010,
    type: 'weapon',
    name: 'EMPPistol #3',
    subtype: 'light',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistol/Item_Weapon_Gun_EMPPistol_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistol/EMPPistolOGGreenEdition.png',
    animationType: 'aim_1h',
    description: 'EMP Pistol'
  },
  {
    id: 10101010,
    type: 'weapon',
    name: 'EMPPistol #4',
    subtype: 'light',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistol/Item_Weapon_Gun_EMPPistol_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistol/EMPPistolFantaziaCamoEdition.png',
    animationType: 'aim_1h',
    description: 'EMP Pistol'
  },
  {
    id: 1010101010,
    type: 'weapon',
    name: 'EMPPistol #5',
    subtype: 'light',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPPistol/Item_Weapon_Gun_EMPPistol_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPPistol/EMPPistolOGPurpleEdition.png',
    animationType: 'aim_1h',
    description: 'EMP Pistol'
  },
  {
    id: 11,
    type: 'weapon',
    name: 'EMPRocketLauncher #1',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPRocketLauncher/Item_Weapon_Launcher_EMPRocketLauncher_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPRocketLauncher/EMPRocketLauncherOGOrangeEdition.png',
    description: 'EMP Rocket Launcher'
  },
  {
    id: 1111,
    type: 'weapon',
    name: 'EMPRocketLauncher #2',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPRocketLauncher/Item_Weapon_Launcher_EMPRocketLauncher_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPRocketLauncher/EMPRocketLauncherOGPinkEdition.png',
    description: 'EMP Rocket Launcher'
  },
  {
    id: 111111,
    type: 'weapon',
    name: 'EMPRocketLauncher #3',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPRocketLauncher/Item_Weapon_Launcher_EMPRocketLauncher_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPRocketLauncher/EMPRocketLauncherProtaStealthEdition.png',
    description: 'EMP Rocket Launcher'
  },
  {
    id: 11111111,
    type: 'weapon',
    name: 'EMPRocketLauncher #4',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPRocketLauncher/Item_Weapon_Launcher_EMPRocketLauncher_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPRocketLauncher/EMPRocketLauncherBonesUpEdition.png',
    description: 'EMP Rocket Launcher'
  },
  {
    id: 1111111111,
    type: 'weapon',
    name: 'EMPRocketLauncher #5',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/EMPRocketLauncher/Item_Weapon_Launcher_EMPRocketLauncher_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/EMPRocketLauncher/EMPRocketLauncherInvisibleHandEdition.png',
    description: 'EMP Rocket Launcher'
  },
  {
    id: 12,
    type: 'armor',
    name: 'GekOGripOverspikedGauntlets #1',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/item_armour_gauntlets_gekogrip_art_Common.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/Henchie/Henchie_item_armour_gauntlets_gekogrip_art_Common.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GekOGripOverspikedGauntlets/GekOGripGauntletsMilitaryGrade.png',
    description: 'Gek-O Grip Overspiked Gauntlets'
  },
  {
    id: 1212,
    type: 'armor',
    name: 'GekOGripOverspikedGauntlets #2',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/item_armour_gauntlets_gekogrip_art_Legendary.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/Henchie/Henchie_item_armour_gauntlets_gekogrip_art_Common.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GekOGripOverspikedGauntlets/GekOGripGauntletsProtaStealth.png',
    description: 'Gek-O Grip Overspiked Gauntlets'
  },
  {
    id: 121212,
    type: 'armor',
    name: 'GekOGripOverspikedGauntlets #3',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/item_armour_gauntlets_gekogrip_art_Rare.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/Henchie/Henchie_item_armour_gauntlets_gekogrip_art_Rare.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GekOGripOverspikedGauntlets/GekOGripGauntletsFantaziaCamo.png',
    description: 'Gek-O Grip Overspiked Gauntlets'
  },
  {
    id: 12121212,
    type: 'armor',
    name: 'GekOGripOverspikedGauntlets #4',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/item_armour_gauntlets_gekogrip_art_SuperRare.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/Henchie/Henchie_item_armour_gauntlets_gekogrip_art_SuperRare.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GekOGripOverspikedGauntlets/GekOGripGauntletsDazzleCamo.png',
    description: 'Gek-O Grip Overspiked Gauntlets'
  },
  {
    id: 1212121212,
    type: 'armor',
    name: 'GekOGripOverspikedGauntlets #5',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/item_armour_gauntlets_gekogrip_art_Uncommon.vrm',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/GekOGripOverspikedGauntlets/Henchie/Henchie_item_armour_gauntlets_gekogrip_art_Uncommon.vrm',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GekOGripOverspikedGauntlets/GekOGripGauntletsOGPink.png',
    description: 'Gek-O Grip Overspiked Gauntlets'
  },
  {
    id: 13,
    type: 'weapon',
    name: 'GloStickAxe #1',
    subtype: 'melee',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickAxe/Item_Weapon_Melee_GloStickAxe_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickAxe/GlowStickAxeOGGreen.png',
    description: 'Glo-Stick Axe'
  },
  {
    id: 1313,
    type: 'weapon',
    name: 'GloStickAxe #2',
    subtype: 'melee',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickAxe/Item_Weapon_Melee_GloStickAxe_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickAxe/GlowStickAxeDazzleCamo.png',
    description: 'Glo-Stick Axe'
  },
  {
    id: 131313,
    type: 'weapon',
    name: 'GloStickAxe #3',
    subtype: 'melee',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickAxe/Item_Weapon_Melee_GloStickAxe_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickAxe/GlowStickAxeOGPink.png',
    description: 'Glo-Stick Axe'
  },
  {
    id: 13131313,
    type: 'weapon',
    name: 'GloStickAxe #4',
    subtype: 'melee',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickAxe/Item_Weapon_Melee_GloStickAxe_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickAxe/basejumpweapons01556.png',
    description: 'Glo-Stick Axe'
  },
  {
    id: 1313131313,
    type: 'weapon',
    name: 'GloStickAxe #5',
    subtype: 'melee',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickAxe/Item_Weapon_Melee_GloStickAxe_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickAxe/GlowStickAxeOGBlue.png',
    description: 'Glo-Stick Axe'
  },
  {
    id: 14,
    type: 'weapon',
    name: 'GloStickGrenade #1',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Common_Art_1.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/GlowStickGrenadeOGOrange.png',
    description: 'Glo-Stick Grenade 1'
  },
  {
    id: 1414,
    type: 'weapon',
    name: 'GloStickGrenade #2',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Legendary_Art_1.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/GlowStickGrenadeProtaStandardIssue.png',
    description: 'Glo-Stick Grenade 1'
  },
  {
    id: 141414,
    type: 'weapon',
    name: 'GloStickGrenade #3',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Rare_Art_1.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/GlowStickGrenadeBonesUp.png',
    description: 'Glo-Stick Grenade 1'
  },
  {
    id: 14141414,
    type: 'weapon',
    name: 'GloStickGrenade #4',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_SuperRare_Art_1.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/GlowStickGrenadeInvisibleHand.png',
    description: 'Glo-Stick Grenade 1'
  },
  {
    id: 1414141414,
    type: 'weapon',
    name: 'GloStickGrenade #5',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Uncommon_Art_1.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/GlowStickGrenadeOGPink.png',
    description: 'Glo-Stick Grenade 1'
  },
  {
    id: 114,
    type: 'weapon',
    name: 'GloStickGrenade #6',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Common_Art_2.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/DiscoBombBonesUpEdition.png',
    description: 'Glo-Stick Grenade 2'
  },
  {
    id: 11414,
    type: 'weapon',
    name: 'GloStickGrenade #7',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Legendary_Art_2.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/DiscoBombProtaStealthEdition.png',
    description: 'Glo-Stick Grenade 2'
  },
  {
    id: 1141414,
    type: 'weapon',
    name: 'GloStickGrenade #8',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Rare_Art_2.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/DiscoBombOGEdition.png',
    description: 'Glo-Stick Grenade 2'
  },
  {
    id: 114141414,
    type: 'weapon',
    name: 'GloStickGrenade #9',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_SuperRare_Art_2.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/DiscoBombInvisibleHandEdition.png',
    description: 'Glo-Stick Grenade 2'
  },
  {
    id: 11414141414,
    type: 'weapon',
    name: 'GloStickGrenade #10',
    subtype: 'light',
    animationType: 'lift',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickGrenade/Item_Weapon_Throw_GloStickGrenade_Uncommon_Art_2.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickGrenade/DiscoBombOGExclusive.png',
    description: 'Glo-Stick Grenade 2'
  },
  {
    id: 15,
    type: 'weapon',
    subtype: 'melee',
    name: 'GloStickNumbChunks #1',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickNumbChunks/Item_Weapon_Melee_GloStickNumbChunks_Common_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickNumbChunks/GlowStickNunChucksOGBayBlue.png',
    description: 'Glow-Stick Numb Chuks'
  },
  {
    id: 1515,
    type: 'weapon',
    subtype: 'melee',
    name: 'GloStickNumbChunks #2',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickNumbChunks/Item_Weapon_Melee_GloStickNumbChunks_Legendary_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickNumbChunks/GlowStickNunChucks3DBassDrip.png',
    description: 'Glow-Stick Numb Chuks'
  },
  {
    id: 151515,
    type: 'weapon',
    subtype: 'melee',
    name: 'GloStickNumbChunks #3',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickNumbChunks/Item_Weapon_Melee_GloStickNumbChunks_Rare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickNumbChunks/GlowStickNunChucksBonesUpSpecial.png',
    description: 'Glow-Stick Numb Chuks'
  },
  {
    id: 15151515,
    type: 'weapon',
    subtype: 'melee',
    name: 'GloStickNumbChunks #4',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickNumbChunks/Item_Weapon_Melee_GloStickNumbChunks_SuperRare_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickNumbChunks/GlowStickNunChucksRugMobCustomMade.png',
    description: 'Glow-Stick Numb Chuks'
  },
  {
    id: 1515151515,
    type: 'weapon',
    subtype: 'melee',
    name: 'GloStickNumbChunks #5',
    glb:   'https://d9mwibab5tete.cloudfront.net/items/vrm/GloStickNumbChunks/Item_Weapon_Melee_GloStickNumbChunks_Uncommon_Art.glb',
    image: 'https://d9mwibab5tete.cloudfront.net/items/img/GloStickNumbChunks/GlowStickNunChucksOGPurple.png',
    description: 'Glow-Stick Numb Chuks'
  },
  {
    id: 16,
    type: 'armor',
    name: 'HardLightSuit #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/item_armour_suit_hardlight_art_Common.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HardLightSuit/HardLightSuitAlamedaAliens.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/Henchie/Henchie_item_armour_suit_hardlight_art_Common.vrm',
    description: 'Hard Light Suit'
  },
  {
    id: 1616,
    type: 'armor',
    name: 'HardLightSuit #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/item_armour_suit_hardlight_art_Legendary.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HardLightSuit/HardLightSuitHalfwayCrooks.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/Henchie/Henchie_item_armour_suit_hardlight_art_Legendary.vrm',
    description: 'Hard Light Suit'
  },
  {
    id: 161616,
    type: 'armor',
    name: 'HardLightSuit #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/item_armour_suit_hardlight_art_Rare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HardLightSuit/HardLightSuitRugMob.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/Henchie/Henchie_item_armour_suit_hardlight_art_Rare.vrm',
    description: 'Hard Light Suit'
  },
  {
    id: 16161616,
    type: 'armor',
    name: 'HardLightSuit #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/item_armour_suit_hardlight_art_SuperRare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HardLightSuit/HardLightSuitRavePandas.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/Henchie/Henchie_item_armour_suit_hardlight_art_SuperRare.vrm',
    description: 'Hard Light Suit'
  },
  {
    id: 1616161616,
    type: 'armor',
    name: 'HardLightSuit #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/item_armour_suit_hardlight_art_Uncommon.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HardLightSuit/HardLightSuitSkeletonCrew.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/HardLightSuit/Henchie/Henchie_item_armour_suit_hardlight_art_Uncommon.vrm',
    description: 'Hard Light Suit'
  },
  {
    id: 17,
    type: 'object',
    subtype: 'equip',
    name: 'NeonDrink #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/NeonDrink/Item_Edible_Drink_NeonDrink_Common_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/NeonDrink/BlueberryCopiumSpritzer.png',
    description: 'Neon Drink',
  },
  {
    id: 1717,
    type: 'object',
    subtype: 'equip',
    name: 'NeonDrink #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/NeonDrink/Item_Edible_Drink_NeonDrink_Legendary_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/NeonDrink/MayorsOfficeLemonSoda.png',
    description: 'Neon Drink',
  },
  {
    id: 171717,
    type: 'object',
    subtype: 'equip',
    name: 'NeonDrink #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/NeonDrink/Item_Edible_Drink_NeonDrink_Rare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/NeonDrink/MayorsOfficeOrangeSoda.png',
    description: 'Neon Drink',
  },
  {
    id: 17171717,
    type: 'object',
    subtype: 'equip',
    name: 'NeonDrink #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/NeonDrink/Item_Edible_Drink_NeonDrink_SuperRare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/NeonDrink/GreenCandleIcedTea.png',
    description: 'Neon Drink',
  },
  {
    id: 1717171717,
    type: 'object',
    subtype: 'equip',
    name: 'NeonDrink #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/NeonDrink/Item_Edible_Drink_NeonDrink_Uncommon_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/NeonDrink/CranberryFUDFizz.png',
    description: 'Neon Drink',
  },
  {
    id: 18,
    type: 'armor',
    name: 'OverspikedBonesuitArms #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Common.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitArms/OverspikedBonesuitArmsOGPink.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Henchie/Henchie_Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Common.vrm',
    description: 'Overspiked Bonesuit Arms'
  },
  {
    id: 1818,
    type: 'armor',
    name: 'OverspikedBonesuitArms #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Legendary.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitArms/OverspikedBonesuitArmsProtaStealth.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Henchie/Henchie_Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Legendary.vrm',
    description: 'Overspiked Bonesuit Arms'
  },
  {
    id: 181818,
    type: 'armor',
    name: 'OverspikedBonesuitArms #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Rare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitArms/OverspikedBonesuitArmsBonesUp.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Henchie/Henchie_Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Rare.vrm',
    description: 'Overspiked Bonesuit Arms'
  },
  {
    id: 18181818,
    type: 'armor',
    name: 'OverspikedBonesuitArms #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Item_Armour_Arms_Bonesuit_Spiked_Over_Art_SuperRare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitArms/OverspikedBonesuitArmsInvisibleHandRemix.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Henchie/Henchie_Item_Armour_Arms_Bonesuit_Spiked_Over_Art_SuperRare.vrm',
    description: 'Overspiked Bonesuit Arms'
  },
  {
    id: 1818181818,
    type: 'armor',
    name: 'OverspikedBonesuitArms #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Uncommon.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitArms/OverspikedBonesuitArmsOGOrange.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitArms/Henchie/Henchie_Item_Armour_Arms_Bonesuit_Spiked_Over_Art_Uncommon.vrm',
    description: 'Overspiked Bonesuit Arms'
  },
  {
    id: 19,
    type: 'armor',
    name: 'OverspikedBonesuitLegs #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitLegs/item_armour_legs_bonesuit_spiked_over_Common.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitLegs/OverspikedBonesuitLegsOGPink.png',
    description: 'Overspiked Bonesuit Legs'
  },
  {
    id: 1919,
    type: 'armor',
    name: 'OverspikedBonesuitLegs #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitLegs/item_armour_legs_bonesuit_spiked_over_Legendary.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitLegs/OverspikedBonesuitLegsProtaStealth.png',
    description: 'Overspiked Bonesuit Legs'
  },
  {
    id: 191919,
    type: 'armor',
    name: 'OverspikedBonesuitLegs #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitLegs/item_armour_legs_bonesuit_spiked_over_Rare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitLegs/OverspikedBonesuitLegsBonesUp.png',
    description: 'Overspiked Bonesuit Legs'
  },
  {
    id: 19191919,
    type: 'armor',
    name: 'OverspikedBonesuitLegs #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitLegs/item_armour_legs_bonesuit_spiked_over_SuperRare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitLegs/OverspikedBonesuitLegsInvisibleHandRemix.png',
    description: 'Overspiked Bonesuit Legs'
  },
  {
    id: 1919191919,
    type: 'armor',
    name: 'OverspikedBonesuitLegs #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedBonesuitLegs/item_armour_legs_bonesuit_spiked_over_Uncommon.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedBonesuitLegs/OverspikedBonesuitLegsOGOrange.png',
    description: 'Overspiked Bonesuit Legs'
  },
  {
    id: 20,
    type: 'armor',
    name: 'OverspikedOversizedBonesuitTorso #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/item_armour_torso_bonesuit_spiked_over_art_Common.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedOversizedBonesuitTorso/OverspikedBonesuitTorsoOGPink.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/Henchie/Henchie_item_armour_torso_bonesuit_spiked_over_art_Common.vrm',
    description: 'Overspiked Oversized Bonesuit Torso'
  },
  {
    id: 2020,
    type: 'armor',
    name: 'OverspikedOversizedBonesuitTorso #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/item_armour_torso_bonesuit_spiked_over_art_Legendary.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedOversizedBonesuitTorso/OverspikedBonesuitTorsoProtaStealth.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/Henchie/Henchie_item_armour_torso_bonesuit_spiked_over_art_Legendary.vrm',
    description: 'Overspiked Oversized Bonesuit Torso'
  },
  {
    id: 202020,
    type: 'armor',
    name: 'OverspikedOversizedBonesuitTorso #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/item_armour_torso_bonesuit_spiked_over_art_Rare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedOversizedBonesuitTorso/OverspikedBonesuitTorsoBonesUp.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/Henchie/Henchie_item_armour_torso_bonesuit_spiked_over_art_Rare.vrm',
    description: 'Overspiked Oversized Bonesuit Torso'
  },
  {
    id: 20202020,
    type: 'armor',
    name: 'OverspikedOversizedBonesuitTorso #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/item_armour_torso_bonesuit_spiked_over_art_SuperRare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedOversizedBonesuitTorso/OverspikedBonesuitTorsoInvisibleHandRemix.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/Henchie/Henchie_item_armour_torso_bonesuit_spiked_over_art_SuperRare.vrm',
    description: 'Overspiked Oversized Bonesuit Torso'
  },
  {
    id: 2020202020,
    type: 'armor',
    name: 'OverspikedOversizedBonesuitTorso #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/item_armour_torso_bonesuit_spiked_over_art_Uncommon.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/OverspikedOversizedBonesuitTorso/OverspikedBonesuitTorsoOGOrange.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/OverspikedOversizedBonesuitTorso/Henchie/Henchie_item_armour_torso_bonesuit_spiked_over_art_Uncommon.vrm',
    description: 'Overspiked Oversized Bonesuit Torso'
  },
  {
    id: 21,
    type: 'object',
    subtype: 'drone',
    name: 'PersonalSurveilanceDrone #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/PersonalSurveilanceDrone/Item_Drone_Personal_Common_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/PersonalSurveilanceDrone/FollowDroneOGGrey.png',
    description: 'Personal Surveilance Drone',
  },
  {
    id: 2121,
    type: 'object',
    subtype: 'drone',
    name: 'PersonalSurveilanceDrone #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/PersonalSurveilanceDrone/Item_Drone_Personal_Legendary_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/PersonalSurveilanceDrone/FollowDroneStealth.png',
    description: 'Personal Surveilance Drone',
  },
  {
    id: 212121,
    type: 'object',
    subtype: 'drone',
    name: 'PersonalSurveilanceDrone #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/PersonalSurveilanceDrone/Item_Drone_Personal_Rare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/PersonalSurveilanceDrone/FollowDroneOGAnodized.png',
    description: 'Personal Surveilance Drone',
  },
  {
    id: 21212121,
    type: 'object',
    subtype: 'drone',
    name: 'PersonalSurveilanceDrone #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/PersonalSurveilanceDrone/Item_Drone_Personal_SuperRare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/PersonalSurveilanceDrone/FollowDroneDazzleCamo.png',
    description: 'Personal Surveilance Drone',
  },
  {
    id: 2121212121,
    type: 'object',
    subtype: 'drone',
    name: 'PersonalSurveilanceDrone #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/PersonalSurveilanceDrone/Item_Drone_Personal_Uncommon_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/PersonalSurveilanceDrone/FollowDroneOGPink.png',
    description: 'Personal Surveilance Drone',
  },
  {
    id: 22,
    type: 'object',
    subtype: 'equip',
    name: 'RamenCarton #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/RamenCarton/Item_Edible_Drink_Ramen_Common_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/RamenCarton/BubbleKitchenRamen.png',
    description: 'Ramen Carton'
  },
  {
    id: 2222,
    type: 'object',
    subtype: 'equip',
    name: 'RamenCarton #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/RamenCarton/Item_Edible_Drink_Ramen_Legendary_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/RamenCarton/HaveYouSeenWarheadRamen.png',
    description: 'Ramen Carton'
  },
  {
    id: 222222,
    type: 'object',
    subtype: 'equip',
    name: 'RamenCarton #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/RamenCarton/Item_Edible_Drink_Ramen_Rare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/RamenCarton/OutofDateRamen.png',
    description: 'Ramen Carton'
  },
  {
    id: 22222222,
    type: 'object',
    subtype: 'equip',
    name: 'RamenCarton #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/RamenCarton/Item_Edible_Drink_Ramen_SuperRare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/RamenCarton/VitroVatFishCakeRamen.png',
    description: 'Ramen Carton'
  },
  {
    id: 2222222222,
    type: 'object',
    subtype: 'equip',
    name: 'RamenCarton #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/RamenCarton/Item_Edible_Drink_Ramen_Uncommon_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/RamenCarton/BroadsideOGRamen.png',
    description: 'Ramen Carton'
  },
  {
    id: 23,
    type: 'armor',
    name: 'SpikedBonesuitLegs #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/SpikedBonesuitLegs/item_armour_legs_bonesuit_spiked_Common.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/SpikedBonesuitLegs/SpikedBonesuitLegsOGPink.png',
    description: 'Spiked Bonesuit Legs'
  },
  {
    id: 2323,
    type: 'armor',
    name: 'SpikedBonesuitLegs #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/SpikedBonesuitLegs/item_armour_legs_bonesuit_spiked_Legendary.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/SpikedBonesuitLegs/SpikedBonesuitLegsProtaStealth.png',
    description: 'Spiked Bonesuit Legs'
  },
  {
    id: 232323,
    type: 'armor',
    name: 'SpikedBonesuitLegs #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/SpikedBonesuitLegs/item_armour_legs_bonesuit_spiked_Rare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/SpikedBonesuitLegs/SpikedBonesuitLegsBonesUp.png',
    description: 'Spiked Bonesuit Legs'
  },
  {
    id: 23232323,
    type: 'armor',
    name: 'SpikedBonesuitLegs #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/SpikedBonesuitLegs/item_armour_legs_bonesuit_spiked_SuperRare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/SpikedBonesuitLegs/SpikedBonesuitLegsInvisibleHandRemix.png',
    description: 'Spiked Bonesuit Legs'
  },
  {
    id: 2323232323,
    type: 'armor',
    name: 'SpikedBonesuitLegs #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/SpikedBonesuitLegs/item_armour_legs_bonesuit_spiked_Uncommon.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/SpikedBonesuitLegs/SpikedBonesuitLegsOGOrange.png',
    description: 'Spiked Bonesuit Legs'
  },
  {
    id: 24,
    type: 'armor',
    name: 'StratfordRexDrip #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Item_Armour_Bally_StratfordRex_Art_Common.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/StratfordRexDrip/StratfordRexDripOGWhite.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Henchie/Henchie_Item_Armour_Bally_StratfordRex_Art_Common.vrm',
    description: 'Stratford Rex Bally'
  },
  {
    id: 2424,
    type: 'armor',
    name: 'StratfordRexDrip #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Item_Armour_Bally_StratfordRex_Art_Legendary.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/StratfordRexDrip/StratfordRexDripOGGoldSpecial.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Henchie/Henchie_Item_Armour_Bally_StratfordRex_Art_Legendary.vrm',
    description: 'Stratford Rex Bally'
  },
  {
    id: 242424,
    type: 'armor',
    name: 'StratfordRexDrip #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Item_Armour_Bally_StratfordRex_Art_Rare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/StratfordRexDrip/StratfordRexDripOGPink.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Henchie/Henchie_Item_Armour_Bally_StratfordRex_Art_Rare.vrm',
    description: 'Stratford Rex Bally'
  },
  {
    id: 24242424,
    type: 'armor',
    name: 'StratfordRexDrip #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Item_Armour_Bally_StratfordRex_Art_SuperRare.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/StratfordRexDrip/StratfordRexDripOGBlack.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Henchie/Henchie_Item_Armour_Bally_StratfordRex_Art_SuperRare.vrm',
    description: 'Stratford Rex Bally'
  },
  {
    id: 2424242424,
    type: 'armor',
    name: 'StratfordRexDrip #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Item_Armour_Bally_StratfordRex_Art_Uncommon.vrm',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/StratfordRexDrip/StratfordRexDripOGGreen.png',
    henchie_glb: 'https://d9mwibab5tete.cloudfront.net/items/vrm/StratfordRexDrip/Henchie/Henchie_Item_Armour_Bally_StratfordRex_Art_Uncommon.vrm',
    description: 'Stratford Rex Bally'
  },
  {
    id: 25,
    type: 'weapon',
    name: 'TrippleBarrell #1',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/BarrelEMPTwinLaunchers/Item_Weapon_Shotgun_BarrelEMPTwinLaunchers_Common_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/BarrelEMPTwinLaunchers/TripleBarrelSawnOffEMPShottyOGGoldSpecial.png',
    description: 'Tripple-Barrell Shotgun'
  },
  {
    id: 2525,
    type: 'weapon',
    name: 'TrippleBarrell #2',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/BarrelEMPTwinLaunchers/Item_Weapon_Shotgun_BarrelEMPTwinLaunchers_Legendary_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/BarrelEMPTwinLaunchers/TripleBarrelSawnOffEMPShottyDazzleCamo.png',
    description: 'Tripple-Barrell Shotgun'
  },
  {
    id: 252525,
    type: 'weapon',
    name: 'TrippleBarrell #3',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/BarrelEMPTwinLaunchers/Item_Weapon_Shotgun_BarrelEMPTwinLaunchers_Rare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/BarrelEMPTwinLaunchers/TripleBarrelSawnOffEMPShottyBonesUpPaint.png',
    description: 'Tripple-Barrell Shotgun'
  },
  {
    id: 25252525,
    type: 'weapon',
    name: 'TrippleBarrell #4',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/BarrelEMPTwinLaunchers/Item_Weapon_Shotgun_BarrelEMPTwinLaunchers_SuperRare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/BarrelEMPTwinLaunchers/TripleBarrelSawnOffEMPShottyRugMobRemix.png',
    description: 'Tripple-Barrell Shotgun'
  },
  {
    id: 2525252525,
    type: 'weapon',
    name: 'TrippleBarrell #5',
    subtype: 'heavy',
    animationType: 'aim_1h',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/BarrelEMPTwinLaunchers/Item_Weapon_Shotgun_BarrelEMPTwinLaunchers_Uncommon_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/BarrelEMPTwinLaunchers/TripleBarrelSawnOffEMPShottyOGPinkEdition.png',
    description: 'Tripple-Barrell Shotgun'
  },
  {
    id: 26,
    type: 'object',
    subtype: 'drone',
    name: 'WingedPill #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/WingedPill/Item_Throw_WingedPill_Common_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/WingedPill/WingedPillOGGeneric.png',
    description: 'Winged Pill Power-Up'
  },
  {
    id: 2626,
    type: 'object',
    subtype: 'drone',
    name: 'WingedPill #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/WingedPill/Item_Throw_WingedPill_Legendary_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/WingedPill/WingedPillVRAAPlacebo.png',
    description: 'Winged Pill Power-Up'
  },
  {
    id: 262626,
    type: 'object',
    subtype: 'drone',
    name: 'WingedPill #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/WingedPill/Item_Throw_WingedPill_Rare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/WingedPill/WingedPillEclecticMethod%27sBadBatch.png',
    description: 'Winged Pill Power-Up'
  },
  {
    id: 26262626,
    type: 'object',
    subtype: 'drone',
    name: 'WingedPill #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/WingedPill/Item_Throw_WingedPill_SuperRare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/WingedPill/WingedPillNounscc0Flavor.png',
    description: 'Winged Pill Power-Up'
  },
  {
    id: 2626262626,
    type: 'object',
    subtype: 'drone',
    name: 'WingedPill #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/WingedPill/Item_Throw_WingedPill_Uncommon_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/WingedPill/WingedPillBonesUpMaxStrength.png',
    description: 'Winged Pill Power-Up'
  },
  {
    id: 27,
    type: 'object',
    subtype: 'companion',
    name: 'HolotagDecoy #1',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HolotagDecoy/Item_Throw_Hologram_Common_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HolotagDecoy/HootagDecyAlamedaAliens.png',
    description: 'Holotag Decoy'
  },
  {
    id: 2727,
    type: 'object',
    subtype: 'companion',
    name: 'HolotagDecoy #2',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HolotagDecoy/Item_Throw_Hologram_Legendary_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HolotagDecoy/HolotagDecoyHalfwayCrooks.png',
    description: 'Holotag Decoy'
  },
  {
    id: 272727,
    type: 'object',
    subtype: 'companion',
    name: 'HolotagDecoy #3',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HolotagDecoy/Item_Throw_Hologram_Rare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HolotagDecoy/HolotagDecoyRugMob.png',
    description: 'Holotag Decoy'
  },
  {
    id: 27272727,
    type: 'object',
    subtype: 'companion',
    name: 'HolotagDecoy #4',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HolotagDecoy/Item_Throw_Hologram_SuperRare_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HolotagDecoy/HolotagDecoyRavePandas.png',
    description: 'Holotag Decoy'
  },
  {
    id: 2727272727,
    type: 'object',
    subtype: 'companion',
    name: 'HolotagDecoy #5',
    glb:         'https://d9mwibab5tete.cloudfront.net/items/vrm/HolotagDecoy/Item_Throw_Hologram_Uncommon_Art.glb',
    image:       'https://d9mwibab5tete.cloudfront.net/items/img/HolotagDecoy/HolotagDecoySkeletonCrew.png',
    description: 'Holotag Decoy'
  }
];

const mutatioToAsset = (mutatio) => {
  mutatio.rawMetadata.glb = mutatio.rawMetadata.animation;
  mutatio.rawMetadata.type = 'object';
  mutatio.rawMetadata.subtype = 'drone_mutatio';
  mutatio.rawMetadata.henchie_glb = mutatio.rawMetadata.glb;
  return mutatio;
};

export default function useItemsListing(figureId, isDiscord, accessToken) {
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  const fetchItems = async (silent = false) => {
    if (!silent) {
      setIsLoading(true);
    }
    try {
      if (figureId && accessToken) {
        const itemsData = await getEquipmentItems(accessToken);
        itemsData.forEach(it => {
          if (it.equipped_by === figureId) {
            it.equipped = true;
            it.slot = it.slot_id;
	  }
	});
        const models = itemsData.map((t) => AssetModel.fromBasejumpEquipment(t, isDiscord));
        setItems(models);
      }
    } catch (e) {
      setItems([]);
      throw e;
    } finally {
      if (!silent) {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchItems();
  }, [accessToken, figureId]);

  return { items, isLoading, fetchItems };
}

export function useBattleItemsListing(address, figure) {
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  const fetchItems = async () => {
    setIsLoading(true);
    const network = IS_PRODUCTION ? Network.BASE_MAINNET : Network.BASE_SEPOLIA;
    try {
      if (address && figure) {
        const [equippedTokenIds, realTokens] = await Promise.all([
          figure.getEquippedItemIds(),
          getAllNftsFromAlchemy(address, BASEJUMP_BI_CONTRACT_ADDRESS, network)
        ]);
        realTokens.forEach((t) => {
          if (equippedTokenIds.includes(t.tokenId)) {
            t.equipped = true;
          }
        });

        if (address === NOT_A_REAL_ID && !IS_PRODUCTION) {
          const tokens = MOCK_ASSETS;
          setItems(tokens.map((t) => AssetModel.fromAlchemyNft(t)));
        } else {
          const models = realTokens.map((t) => AssetModel.fromAlchemyNft(t, false));
          setItems(models);
        }
      }
    } catch (e) {
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [address]);

  return { items, isLoading };
}
